export enum MenuPlanningTab {
    CALENDAR = "CALENDAR",
    MENUS = "MENUS",
    DIGITAL_SIGNAGE = "DIGITAL_SIGNAGE",
}

/** The rendered tab order — MenuPlanning builds its tabs from this list. */
export const MENU_PLANNING_TAB_ORDER: ReadonlyArray<MenuPlanningTab> = [
    MenuPlanningTab.CALENDAR,
    MenuPlanningTab.MENUS,
    MenuPlanningTab.DIGITAL_SIGNAGE,
]
